/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Lang } from 'src/app/model/lang';
import { StandardDesignParameters, StandardDynamicComponent, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { selectDeviceTabIndex } from 'src/app/store/home/home.selector';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ThermoLog } from 'src/app/model/thermo';
import 'chartjs-adapter-date-fns';
import moment from 'moment';
import * as DeviceThActions from 'src/app/store/device-th/device-th.actions';
import { selectThLogData, selectThLogLoading } from 'src/app/store/device-th/device-th.selector';

@Component({
	selector: 'app-thermo-log',
	templateUrl: './thermo-log.component.html',
	providers: [ConfirmationService, DialogService]
})

export class ThermoLogComponent implements OnInit, OnDestroy {
	currentLang$: Observable<Lang> = new Observable();
	currentLangSub: Subscription | undefined;
	tabIndex: number;
	tabIndex$: Observable<number | undefined>;
	tabIndexSub: Subscription | undefined;

	thLogData$: Observable<ThermoLog | undefined>;
	thLogDataSub: Subscription | undefined;
	thLogLoading$: Observable<boolean | undefined>;
	thLogLoadingSub: Subscription | undefined;

	loading: boolean;
	logData: ThermoLog;

	filterGroup: FormGroup;
	filterSub: Subscription;

	dateTransform: DatePipe;
	intervalType: any[];
	minDate: Date = new Date("1900-01-01");
	today = new Date();
	maxDate = new Date();

	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	chartHumidity: any;
	optionsHumidity: any;
	chartTemp: any;
	optionsTemp: any;
	chartOnOff: any;
	optionsOnOff: any;
	chartOnline: any;
	optionsOnline: any;

	chartOnOffBar: any;
	optionsOnOffBar: any;

	on: string;
	off: string;
	online: string;
	offline: string;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	COLUMN_TITLE_MIN_WD = 647;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_MX7 = 1700;
	LG_WIDTH = 1500;
	MAX_MD_WIDTH_SHORT = 858;

	constructor(
		//private dialog: MatDialog,
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.tabIndex$ = this.store.select(selectDeviceTabIndex);
		this.thLogLoading$ = this.store.select(selectThLogLoading);
		this.thLogData$ = this.store.select(selectThLogData);
	}

	ngOnInit(): void {
		this.loading = true;
		this.logData = null;
		this.today = new Date();
		this.maxDate = new Date();
		this.maxDate.setHours(23);
		this.maxDate.setMinutes(59);
		this.on = this.translate.instant('CHARTS_TH_ON');
		this.off = this.translate.instant('CHARTS_TH_OFF');
		this.online = this.translate.instant('CHARTS_TH_ONLINE');
		this.offline = this.translate.instant('CHARTS_TH_OFFLINE');

		/*--
		NONE: 0,
		BOARD_USER_UNDEFINED: 200,
		KEY: 201,
		TIMER_EVENT: 202,
		INPUT_ON: 203,
		INPUT_OFF: 204,*/
		this.intervalType = [
			{ value: 'day', label: 'DAY' },
			{ value: 'week', label: 'WEEK' },
			{ value: 'month', label: 'MONTH' },
			{ value: 'year', label: 'YEAR' },
		];

		//this.generateChartsTest();

		const startDate = new Date(this.today.getTime());
		const curreLang = this.translate.currentLang;
		this.dateTransform = new DatePipe(curreLang);
		this.filterGroup = new FormGroup({
			'searchFilter': new FormControl(''),
			'type': new FormControl(this.intervalType[0].value),
			'startDateTime': new FormControl(startDate, Validators.required),
		});

		this.tabIndexSub = this.tabIndex$?.subscribe(
			async (tabIndex: number) => {
				this.tabIndex = tabIndex;
				this.dispatchGetThLog();
			});

		this.thLogDataSub = this.thLogData$?.subscribe(thLogData => {
			this.logData = thLogData;
			if (this.logData !== null) {
				this.generateHumidity();
				this.generateTemp();
				if (this.getTypeData() === 'day') {
					this.generateOnOffLine();
				} else {
					this.generateOnOffBar();
				}
				this.generateOnline();
			}
		});
		this.currentLangSub = this.currentLang$?.subscribe(() => {
			this.on = this.translate.instant('CHARTS_TH_ON');
			this.off = this.translate.instant('CHARTS_TH_OFF');
			this.online = this.translate.instant('CHARTS_TH_ONLINE');
			this.offline = this.translate.instant('CHARTS_TH_OFFLINE');
		});

		this.thLogLoadingSub = this.thLogLoading$?.subscribe(thLogLoading => {
			this.loading = thLogLoading;
		});

		this.onResize();

		/*this.filterSub = this.filterGroup.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			this.dispatchGetThLog();
		});*/
	}

	dispatchGetThLog(): void {
		if (this.isSelectTab()) {
			const startDateTime = this.f.startDateTime.value;
			this.store.dispatch(DeviceThActions.getThLog({
				from: startDateTime,
				intervaltype: this.f.type.value,
				location: 'Europe/Rome'
			}));
		}
	}

	ngOnDestroy(): void {
		this.currentLangSub?.unsubscribe();
		this.tabIndexSub?.unsubscribe();
		this.thLogDataSub?.unsubscribe();
		this.thLogLoadingSub?.unsubscribe();
	}


	isTh(): boolean {
		//return (this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.MTMACONNECT) && this.tabIndex === 9); // TAB INDEX FOR MTMACONNECT CALLLOG IS 9
		return (this.tabIndex === 2); // TAB INDEX FOR MTMACONNECT IS 6 tab only for mtma

	}

	isSelectTab(): boolean {
		return this.isTh();
	}

	changeDropdownValue() {
		this.dispatchGetThLog();
	}

	changeCalendarValue() {
		this.dispatchGetThLog();
	}

	/* refresh(): void {
		this.dispatchGetThLog();
	} */

	getLabel(): string {
		const type = this.f.type.value;
		switch (type) {
			case 'month':
				return this.translate.instant('MONTH');
			case 'year':
				return this.translate.instant('YEAR');
		}
		return this.translate.instant('DATE'); // default, day, week
	}

	generateHumidity(): void {
		let typeUnit = 'hour';
		if (this.logData.IntervalType === 'week') {
			typeUnit = 'day';
		} else if (this.logData.IntervalType === 'month') {
			typeUnit = 'day';
		} else if (this.logData.IntervalType === 'year') {
			typeUnit = 'month';
		}
		const dataHumidity = [];
		if (this.logData !== null && this.logData.Humidity !== undefined) {
			for (const hum of this.logData.Humidity.List) {
				dataHumidity.push({
					x: new Date(hum.Timestamp * 1000),
					y: hum.Value
				});
			}
		}
		this.chartHumidity = {
			datasets: [
				{
					label: this.translate.instant('CHARTS_TH_HUMIDITY'),
					data: dataHumidity,
					borderColor: ['#2f8ee5'],
					backgroundColor: ['rgba(47, 142, 229, 0.05)'],
				},
			],
			responsive: true,
		};
		this.optionsHumidity = {
			animation: {
				duration: 0,
			},
			plugins: {
				legend: {
					labels: {
						color: 'black',
					},
				},
			},
			scales: {
				x: {
					ticks: {
						color: 'black',
					},
					type: 'time', // Specifica che l'asse X è di tipo "time"
					time: {
						unit: typeUnit, // Mostra le ore
					},
					grid: {
						display: true,
					},
				},
				y: {
					min: 0,
					max: 100,
					ticks: {
						color: 'black',
					},
					grid: {
						display: true,
					},
				},
			},
		};
	}


	generateTemp(): void {
		let typeUnit = 'hour';
		if (this.logData.IntervalType === 'week') {
			typeUnit = 'day';
		} else if (this.logData.IntervalType === 'month') {
			typeUnit = 'day';
		} else if (this.logData.IntervalType === 'year') {
			typeUnit = 'month';
		}
		const datasets = [];
		const dataInternalTemperature = [];
		if (this.logData !== null && this.logData.InternalTemperature !== undefined) {
			for (const intT of this.logData.InternalTemperature.List) {
				dataInternalTemperature.push({
					x: new Date(intT.Timestamp * 1000),
					y: intT.Value
				});
			}
		}
		datasets.push({
			label: this.translate.instant('CHARTS_TH_TEMP_INT'),
			data: dataInternalTemperature,
			borderColor: ['blue'],
			backgroundColor: ['rgba(47, 142, 229, 0.05)'],
			borderWidth: 2,
			/*fill: false,
			tension: 0.1,
			pointStyle: false,*/
		},);
		const dataExternalTemperature = [];
		if (this.logData !== null && this.logData.ExternalTemperature !== undefined) {
			for (const intT of this.logData.ExternalTemperature.List) {
				dataExternalTemperature.push({
					x: new Date(intT.Timestamp * 1000),
					y: intT.Value
				});
			}
		}
		datasets.push({
			label: this.translate.instant('CHARTS_TH_TEMP_EXT'),
			data: dataExternalTemperature,
			borderColor: ['orange'],
			backgroundColor: ['rgba(47, 142, 229, 0.05)'],
			borderWidth: 2,
			/*fill: false,
			tension: 0.1,
			pointStyle: false,*/
		});
		const dataSetPoint = [];
		if (this.logData !== null && this.logData.SetPoint !== undefined) {
			for (const setP of this.logData.SetPoint.List) {
				dataSetPoint.push({
					x: new Date(setP.Timestamp * 1000),
					y: setP.Value
				});
			}
		}
		if (this.logData.IntervalType === 'day') {
			datasets.push({
				label: this.translate.instant('CHARTS_TH_SET_POINT'),
				data: dataSetPoint,
				borderColor: ['green'],
				backgroundColor: ['rgba(47, 142, 229, 0.05)'],
				borderWidth: 2,
				/*fill: false,
				tension: 0.1,
				pointStyle: false,*/
				stepped: true,
			},);
		}

		this.chartTemp = {
			datasets: datasets,
			responsive: true,
		};
		this.optionsTemp = {
			animation: {
				duration: 0,
			},
			plugins: {
				legend: {
					labels: {
						color: 'black',
					},
				},
			},
			scales: {
				x: {
					ticks: {
						color: 'black',
					},
					type: 'time', // Specifica che l'asse X è di tipo "time"
					time: {
						unit: typeUnit, // Mostra le ore
					},
					grid: {
						display: true,
					},
				},
				y: {
					ticks: {
						color: 'black',
					},
					grid: {
						display: true,
					},
				},
			},
		};
	}

	generateOnOffLine(): void {
		let typeUnit = 'hour';
		if (this.logData.IntervalType === 'week') {
			typeUnit = 'day';
		} else if (this.logData.IntervalType === 'month') {
			typeUnit = 'day';
		} else if (this.logData.IntervalType === 'year') {
			typeUnit = 'month';
		}
		const datasets = [];
		const dataAcc = [];
		if (this.logData !== null && this.logData.PowerOnTime !== undefined
			&& this.logData.PowerOnTime.List !== undefined && this.logData.PowerOnTime.List !== null) {
			for (const powe of this.logData.PowerOnTime.List) {
				if (powe.Value) {
					dataAcc.push({
						x: new Date(powe.Timestamp * 1000),
						y: 1
					});
				} else {
					dataAcc.push({
						x: new Date(powe.Timestamp * 1000),
						y: 0
					});
				}
			}
			if (this.logData.PowerOnTime.List.length > 0) {
				const date = new Date(this.logData.PowerOnTime.List[this.logData.PowerOnTime.List.length - 1].Timestamp * 1000);
				if (moment(date).isSame(new Date(), "day")) {
					date.setHours(new Date().getHours());
					date.setMinutes(new Date().getMinutes());
					date.setSeconds(new Date().getSeconds());
				} else {
					date.setHours(23);
					date.setMinutes(59);
					date.setSeconds(0);
				}
				dataAcc.push({
					x: date,
					y: this.logData.PowerOnTime.List[this.logData.PowerOnTime.List.length - 1].Value ? 1 : 0
				});
			}
		}
		datasets.push({
			label: this.translate.instant('CHARTS_TH_ON_OFF'),
			data: dataAcc,
			borderColor: 'rgb(8, 250, 126)',
			backgroundColor: ['rgba(8, 250, 126, 0.05)'],
			borderWidth: 2,
			/*fill: false,
			tension: 0.1,
			pointStyle: false,*/
			stepped: true,
		},);

		this.chartOnOff = {
			datasets: datasets,
			responsive: true,
		};
		this.optionsOnOff = {
			animation: {
				duration: 0,
			},
			plugins: {
				legend: {
					labels: {
						color: 'black',
					},
				},
			},
			scales: {
				x: {
					ticks: {
						color: 'black',
					},
					type: 'time', // Specifica che l'asse X è di tipo "time"
					time: {
						unit: typeUnit, // Mostra le ore
					},
					grid: {
						display: true,
					},
				},
				y: {
					ticks: {
						color: 'black',
						callback: function (value) {
							if (value === 1) {
								return 1;
							}
							if (value === 0) {
								return 0;
							}
							return '';
						}
					},
					grid: {
						display: true,
					},
				},
			},
		};
	}



	generateOnOffBar(): void {
		const labels = [];
		if (this.logData.IntervalType === 'week') {
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_MONDAY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_TUESDAY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_WEDNESDAY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_THURSDAY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_FRIDAY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_SATURDAY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_SUNDAY')));
		} else if (this.logData.IntervalType === 'month') {
			for (let i = 1; i <= this.logData.PowerOnTime.List.length; i++) {
				labels.push('' + i);
			}
		} else if (this.logData.IntervalType === 'year') {
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_JANUARY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_FEBRUARY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_MARCH')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_APRIL')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_MAY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_JUNE')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_JULY')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_AUGUST')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_SEPTEMBER')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_OCTOBER')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_NOVEMBER')));
			labels.push(this.translate.instant(this.translate.instant('CHARTS_TH_DECEMBER')));
		}
		const datas = [];
		for (const pow of this.logData.PowerOnTime.List) {
			datas.push(pow.Value);
		}
		this.chartOnOffBar = {
			labels: labels,
			datasets: [
				{
					label: this.translate.instant('CHARTS_TH_ON_MIN'),
					data: datas,
					backgroundColor: 'rgba(8, 250, 126, 0.2)',
					borderColor: 'rgb(8, 250, 126)',
					borderWidth: 1
				}
			]
		};

		this.optionsOnOffBar = {
			scales: {
				y: {
					beginAtZero: true,
					grid: {
						drawBorder: false
					}
				},
				x: {
					grid: {
						drawBorder: false
					}
				}
			}
		};
	}

	generateOnline(): void {
		let typeUnit = 'hour';
		if (this.logData.IntervalType === 'week') {
			typeUnit = 'day';
		} else if (this.logData.IntervalType === 'month') {
			typeUnit = 'day';
		} else if (this.logData.IntervalType === 'year') {
			typeUnit = 'month';
		}
		const datasets = [];
		const dataOnline = [];
		if (this.logData !== null && this.logData.ConnectionEvents !== undefined &&
			this.logData.ConnectionEvents.List !== undefined && this.logData.ConnectionEvents.List !== null) {
			/*if (this.logData.PowerOnTime.List.length > 0) {
				const date = new Date(this.logData.PowerOnTime.List[0].Timestamp * 1000);
				date.setHours(0);
				date.setMinutes(1);
				date.setSeconds(0);
				dataOnline.push({
					x: date,
					y: this.logData.PowerOnTime.List[0].Value ? 0 : 1
				});
			}*/
			for (const conn of this.logData.ConnectionEvents.List) {
				//let startDate;
				if (conn.Value) {
					dataOnline.push({
						x: new Date(conn.Timestamp * 1000),
						y: 1
					});
				} else {
					dataOnline.push({
						x: new Date(conn.Timestamp * 1000),
						y: 0
					});
				}
			}
			if (this.logData.ConnectionEvents.List.length > 0) {
				const date = new Date(this.logData.ConnectionEvents.List[this.logData.ConnectionEvents.List.length - 1].Timestamp * 1000);
				if (moment(date).isSame(new Date(), "day")) {
					date.setHours(new Date().getHours());
					date.setMinutes(new Date().getMinutes());
					date.setSeconds(new Date().getSeconds());
				} else {
					date.setHours(23);
					date.setMinutes(59);
					date.setSeconds(0);
				}
				dataOnline.push({
					x: date,
					y: this.logData.ConnectionEvents.List[this.logData.ConnectionEvents.List.length - 1].Value ? 1 : 0
				});
			}
		}
		datasets.push({
			label: this.translate.instant('CHARTS_TH_ONLINE_OFFLINE'),
			data: dataOnline,
			borderColor: ['red'],
			backgroundColor: ['rgba(47, 142, 229, 0.05)'],
			borderWidth: 2,
			/*fill: false,
			tension: 0.1,
			pointStyle: false,*/
			stepped: true,
		},);

		this.chartOnline = {
			datasets: datasets,
			responsive: true,
		};
		this.optionsOnline = {
			animation: {
				duration: 0,
			},
			plugins: {
				legend: {
					labels: {
						color: 'black',
					},
				},
			},
			scales: {
				x: {
					ticks: {
						color: 'black',
					},
					type: 'time', // Specifica che l'asse X è di tipo "time"
					time: {
						unit: typeUnit, // Mostra le ore
					},
					grid: {
						display: true,
					},
				},
				y: {
					ticks: {
						color: 'black',
						callback: function (value) {
							if (value === 1) {
								return 1;
							}
							if (value === 0) {
								return 0;
							}
							return '';
						}
					},
					grid: {
						display: true,
					},
				},
			},
		};
	}

	get f(): any {
		return this.filterGroup.controls;
	}

	getIntervalDate(): string {
		if (this.logData == undefined || this.logData.IntervalType == undefined) {
			return '';
		}
		const str = String(this.translate.instant(this.logData.IntervalType)).toUpperCase();
		if (this.logData.IntervalType == 'day') {
			return str + '  ' + moment(new Date(this.logData.From * 1000)).format('DD/MM/yyyy');
		}
		if (this.logData.IntervalType == 'week') {
			return str + '  ' + moment(new Date(this.logData.From * 1000)).format('DD/MM/yyyy') + ' - ' + moment(new Date(this.logData.To * 1000)).subtract(1, 'days').format('DD/MM/yyyy');
		}
		if (this.logData.IntervalType == 'month') {
			return str + '  ' + moment(new Date(this.logData.From * 1000)).format('MM/yyyy');
		}
		if (this.logData.IntervalType == 'year') {
			return str + '  ' + moment(new Date(this.logData.From * 1000)).format('yyyy');
		}
		return '';
	}

	getTypeData(): string {
		if (this.logData == undefined || this.logData.IntervalType == undefined) {
			return '';
		}
		return this.logData.IntervalType;
	}


	// exportLog(): void {
	// 	this.store.dispatch(DeviceThActions.getLogThExportReset());
	// 	this.dialogService.open(ThermoExportLogDialogComponent, {
	// 		header: this.translate.instant('EXPORT_METRICS_LIST'),
	// 		width: '70vw',
	// 		breakpoints: { '1120px': '98vw' },
	// 		contentStyle: { overflow: 'auto' },
	// 	});
	// }

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
		if (this.logData !== null) {
			this.generateHumidity();
			this.generateTemp();
			if (this.getTypeData() === 'day') {
				this.generateOnOffLine();
			} else {
				this.generateOnOffBar();
			}
			this.generateOnline();
		}
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	col3ResponsiveStd(): string {
		return StandardPageLayout.col3ResponsiveStd(this.screenWidth);
	}

	col4Responsive(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}

	col2Responsive(): string {
		return (this.screenWidth >= StandardDesignParameters.MIN_WIDTH_MX7_LATER) ? "col-2 px-4" : this.onExtendedMobile() ? 'col-12' : 'col-6';
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicAutocomplete(): string {
		return StandardDynamicComponent.dynamicAutocomplete(this.screenWidth);
	}

	col6Responsive(): string {
		return StandardPageLayout.col6ResponsiveNoPadding(this.screenWidth);
	}

	customPadding(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}